const initialState = {
	lang: undefined,
	external: process.env.REACT_APP_EXTERNAL,
}

export default function commonReducer(state = initialState, action) {
	switch (action.type) {
		case 'SET_LANG': {
			return {
				...state,
				lang: action.lang
			}
		}
		case "SET_EXTERNAL": {
			return {
				...state,
				external: action.external
			}
		}
		default:
			return state
	}
}